import { Col, Row } from 'emotion-flex';
import React, { FC, ReactNode } from 'react';
import Container from '../Reimbursement/Container';
import {
  MonoFontLabel,
  OpenSansParagraph,
  RecoletaHeading,
} from '../common/typography';

import presets from '../../styles/presets';
import { useIntl } from 'react-intl';
import ImageTextBulletItems from '../common/ImageTextBulletItems';
import TypeformEmbedButton from '../Homepage/2023wk35/TypeformOverlay';
import { markdownText } from '../../pages/doctors';
import VideoOverlay from '../VideoOverlay';
import CaraCareVideo from '../../assets/svgs/product/img-video_thumb-linda.png';

export enum HeaderType {
  Bulleted,
  Text,
}

export interface BulletedHeader {
  type: HeaderType.Bulleted;
  prefix: string;
  title: string;
  text: string;
  bulletItems: string[];
  svg: string;
  buttonText: string;
  rightElement: ReactNode;
  rightElementType: 'video' | 'image';
  buttonUrl: string;
}

export interface TextHeader {
  type: HeaderType.Text;
  prefix: string;
  title: string;
  buttonText: string;
  rightElement: ReactNode;
  rightElementType: 'video' | 'image';
  buttonUrl: string;
  text?: string;
}

type HeaderContent = BulletedHeader | TextHeader;

interface Props {
  content: HeaderContent;
}

const Header: FC<Props> = ({ content }) => {
  const intl = useIntl();
  const isMobile: boolean =
    typeof window !== 'undefined' &&
    window.matchMedia('@media (max-width: 768px)').matches;

  return (
    <Container
      css={{
        maxWidth: 900,
        marginTop: isMobile ? 0 : '2rem',
      }}
    >
      <Row>
        <Col
          xs={12}
          sm={12}
          md={content.rightElementType === 'video' ? 6 : 8}
          lg={content.rightElementType === 'video' ? 6 : 8}
          css={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            marginTop: 40,
            paddingRight: '5px',

            [presets.md]: {
              marginTop: 0,
              textAlign: 'left',
              alignItems: 'flex-start',
            },
          }}
        >
          <MonoFontLabel
            css={(theme) => ({
              fontWeight: 700,
              letterSpacing: '2px',
              lineHeight: '18px',
              color: theme.colors.primaryDark,
            })}
          >
            {content.prefix}
          </MonoFontLabel>
          <RecoletaHeading
            css={{
              fontSize: '32px',
              fontWeight: 500,
              lineHeight: '38px',
            }}
          >
            {markdownText(content.title)}
          </RecoletaHeading>
          {content.type === HeaderType.Bulleted ? (
            <>
              <ImageTextBulletItems
                containerStyle={{
                  justifyContent: isMobile ? 'center' : 'left',
                  marginBottom: 0,
                }}
                textStyle={{
                  textAlign: isMobile ? 'center' : 'left',
                  justifyContent: isMobile ? 'center' : 'left',
                }}
                bulletItems={content.bulletItems}
                svg={content.svg}
              />

              {/* <OpenSansParagraph
              css={{
                color: '#000',
                fontWeight: 700,
                marginBottom: 20,
                opacity: 1,
              }}
            >
              {content.text}
            </OpenSansParagraph> */}
          </>
          ) : (
            <OpenSansParagraph
              css={{
                maxWidth: 400,
                marginBottom:
                  content.rightElementType === 'image' ? 0 : '1.5rem',
              }}
            >
              {markdownText(content.text)}
            </OpenSansParagraph>
          )}

          {!isMobile && (
            <TypeformEmbedButton
              index={2}
              typeformId={content.buttonUrl}
              buttonText={
                content.buttonText
                  ? content.buttonText
                  : intl.formatMessage({
                      id: 'homepage.problems.cta.text',
                      defaultMessage: 'Kostenfreie Therapie Starten',
                    })
              }
              buttonStyle={(theme) => ({
                margin: '5px 10px 5px 0',
                backgroundColor: theme.colors.primary,
                color: '#ffffff',
                fontWeight: 700,
                padding: '1rem 1rem',
                borderRadius: 8,
              })}
            />
          )}
          <OpenSansParagraph
            css={{
              marginTop: 20,
              maxWidth: 400,
            }}
          >
            {intl.locale === 'en' &&
              intl.formatMessage({
                id: 'new.landingpage.disclaimer',
                defaultMessage:
                  '*Therapy is currently only available in German.',
              })}
          </OpenSansParagraph>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <VideoOverlay
            buttonType="image"
            link="https://www.youtube.com/embed/i9oQTvfrCjE"
            thumbnail={CaraCareVideo}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Header;
